import { BusinessSeller, UpdateBusinessSeller } from '@/entities/businessSeller';
import { Api } from './api/axios-config';

export class BusinessSellerService{
  private static api = Api();

  public static async getBusinessSeller(businessId: number){
    const response = await this.api.get<any>(`/BSeller/${businessId}`);
    if(response.status === 200){
      return response.data;
    }
    return null;
  }

  public static async upsertBusinessSeller(businessId: number, sellerId: number) {
    const response= await this.api.post<any>(`/Seller/upsert/${Number(businessId)}`,{
        SellerId: Number(sellerId)
    });
    if(response.status === 201){
        const newBusinessSeller ={
          id: response.data.id,
          commission: response.data.commission,
          indicatorId: response.data.indicatorId,
          businessId: response.data.businessId,
        };
        return newBusinessSeller;
      }
  }

  public static async createBusinessSeller(businessSeller:BusinessSeller){
    const response = await this.api.post<any>('/BSeller', {
      commission: businessSeller.commission,
      indicatorId: businessSeller.indicatorId,
      businessId: businessSeller.businessId,
    });
    if(response.status === 201){
      const newBusinessSeller ={
        id: response.data.id,
        commission: response.data.commission,
        indicatorId: response.data.indicatorId,
        businessId: response.data.businessId,
      };
      return newBusinessSeller;
    }
  }

  public static async deleteBusinessSeller(id:number, businessId:number){
    await this.api.delete<any>(`/BSeller/${id}/${businessId}`);
  }
}
